import Tag from 'antd/es/tag';
import React from 'react';

export type EntityType = 'agent' | 'dataset' | 'execution' | 'generic';

export interface StatusTagProps {
  status: string;
  type?: EntityType;
  children?: React.ReactNode;
}

export const StatusTag: React.FC<StatusTagProps> = ({
  status,
  type = 'generic',
  children,
}) => {
  const getColor = (status: string, type: EntityType): string => {
    const colorMaps: Record<EntityType, Record<string, string>> = {
      agent: {
        active: 'success',
        inactive: 'default',
        draft: 'processing',
      },
      dataset: {
        ready: 'success',
        current: 'success',
        draft: 'processing',
        archived: 'default',
        processing: 'processing',
      },
      execution: {
        completed: 'success',
        running: 'processing',
        pending: 'default',
        failed: 'error',
        cancelled: 'warning',
        paused: 'warning',
      },
      generic: {
        success: 'success',
        active: 'success',
        ready: 'success',
        processing: 'processing',
        pending: 'default',
        draft: 'processing',
        error: 'error',
        failed: 'error',
        warning: 'warning',
        cancelled: 'warning',
        inactive: 'default',
        archived: 'default',
        expired: 'warning',
        admin: 'gold',
        member: 'default',
      },
    };

    const statusLower = status.toLowerCase();
    const typeColors = colorMaps[type] || colorMaps.generic;
    return (
      typeColors[statusLower] || colorMaps.generic[statusLower] || 'default'
    );
  };

  const formatStatus = (status: string): string => {
    // Convert camelCase or snake_case to Title Case
    return status
      .replace(/([A-Z])/g, ' $1')
      .replace(/_/g, ' ')
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  };

  const color = getColor(status, type);
  const displayText = children || formatStatus(status);

  return <Tag color={color}>{displayText}</Tag>;
};

export default StatusTag;
